import { InjectionToken } from '@angular/core';

import { ThemeConfig } from '../types';

export const THEME_CONFIG = new InjectionToken<ThemeConfig>('THEME_CONFIG');
